import script from "./PopupAdaugareDetaliu.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupAdaugareDetaliu.vue?vue&type=script&lang=ts&setup=true"

import "./PopupAdaugareDetaliu.vue?vue&type=style&index=0&id=b16c9eae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b16c9eae"]])

export default __exports__